<template>
    <div class="images-content">
        <v-dialog :value="imageFileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ active_img.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                        <v-btn icon @click="downloadFile(active_img.id)">
                            <v-icon color="white">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn dark icon @click="closeDialog">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                    <v-img :src="active_img.path"></v-img>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- Upload section -->
        <v-row no-gutters justify="space-between">
            <v-col cols="9">
                <v-file-input
                    multiple
                    chips
                    :label="'Upload images' | t"
                    :value="files"
                    @change="files = $event"
                    accept="image/*"
                />
            </v-col>
            <v-col cols="3" class="text-end">
                <v-btn
                    @click="submitUpload"
                    :disabled="!files || files.length <= 0"
                    class="mt-3 ml-3 success"
                >
                    {{ "Upload" | t }}
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="mb-3"></v-divider>

        <v-list>
            <v-list-item
                v-for="file in activeClient.images"
                :key="file.id"
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-avatar @click="openImageDialog(file)">
                    <v-img :src="file.path" />
                </v-list-item-avatar>
                <v-list-item-content @click="openImageDialog(file)">
                    <v-list-item-title v-text="file.name" />
                    <v-list-item-subtitle v-text="file.date" />
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn icon @click="downloadFile(file.id)">
                            <v-icon color="blue lighen-1">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn icon @click="removeFile(file.id)">
                            <v-icon color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="activeClient && activeClient.images && activeClient.images.length <= 0">
                <v-list-item-content>
                    <v-list-item-title>{{ "No images found" | t }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";
import settings from "@/settings";

export default {
    name: "image-tab",
    data() {
        return {
            active_img: [],
            files: []
        };
    },
    computed: {
        ...mapState("ClientStore", ["activeClient", "imageFileDialog"])
    },
    methods: {
        openImageDialog(file) {
            this.active_img = file;
            Store.commit("ClientStore/setImageFileDialog", true);
        },
        closeDialog() {
            this.active_img = [];
            Store.commit("ClientStore/setImageFileDialog", false);
        },
        downloadFile(id) {
            let params = "?act=download_file";
            params += "&file_id=" + id;
            window.location.href = settings.api_url + "/file" + params;
        },
        submitUpload() {
            if (this.files && this.files.length > 0) {
                Store.dispatch("ClientStore/uploadClientFiles", {
                    clientId: this.activeClient.id,
                    files: this.files
                });
                this.files = [];
            }
        },
        removeFile(id) {
            if (confirm(this.t("Are you sure you want to delete this image?"))) {
                Store.dispatch("ClientStore/deleteClientFile", {
                    fileId: id,
                    clientId: this.activeClient.id
                });
            }
        }
    }
};
</script>

<style scoped>
.images-content {
    padding: 0 20px 12px 20px;
}
</style>
